import './security-modal.scss';

import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/Client/AutoCredit/shared/ui';
import { Button } from '@/components/Shared/ui';
import EyeIcon from '@/media/icons/eye.svg?react';
import LockIcon from '@/media/icons/lock-empty.svg?react';
import ShieldCheckIcon from '@/media/icons/shield-check.svg?react';
import ShieldIcon from '@/media/icons/shield.svg?react';
import TriangleAlertIcon from '@/media/icons/triangle-alert.svg?react';

interface IProps {
  isOpened: boolean;
  onClose: () => void;
}

const SecurityModal: React.FC<IProps> = ({ isOpened, onClose }) => {
  const { t } = useTranslation();

  const infoList = [
    {
      icon: <TriangleAlertIcon />,
      text: t('otp-validation.security-modal.text-1'),
      bgColor: '#FFEACF',
      color: '#FF4500'
    },
    {
      icon: <EyeIcon />,
      text: t('otp-validation.security-modal.text-2'),
      bgColor: '#D7E4FF',
      color: '#005CFF'
    },
    {
      icon: <ShieldCheckIcon />,
      text: t('otp-validation.security-modal.text-3'),
      bgColor: '#DBFBE5',
      color: '#00B233'
    },
    {
      icon: <LockIcon />,
      text: t('otp-validation.security-modal.text-4'),
      bgColor: '#EFE0FF',
      color: '#A10CFF'
    }
  ];

  return (
    <Modal
      title={
        <div className="security-modal__flex-line">
          <span
            className="security-modal__icon"
            style={{
              '--bg-color': '#D7E4FF',
              '--color': '#005CFF'
            }}
          >
            <ShieldIcon />
          </span>
          <p className="security-modal__title">
            {t('otp-validation.security-modal.title')}
          </p>
        </div>
      }
      className="security-modal"
      onClose={onClose}
      open={isOpened}
      classNames={{
        container: 'security-modal__content'
      }}
      width={540}
      destroyOnHidden
      mask={{ closable: false }}
    >
      <p className="security-modal__subtitle">
        {t('otp-validation.security-modal.subtitle')}
      </p>

      {infoList.map((item) => (
        <div className="security-modal__flex-line" key={item.text}>
          <span
            className="security-modal__icon"
            style={{
              '--bg-color': item.bgColor,
              '--color': item.color
            }}
          >
            {item.icon}
          </span>
          <p className="security-modal__text">{item.text}</p>
        </div>
      ))}

      <Button
        className="security-modal__button"
        onClick={onClose}
        variant="filled-black"
        fullWidth
      >
        {t('otp-validation.continue')}
      </Button>
    </Modal>
  );
};

export default SecurityModal;
